<script>
import { defaultTo, pipe, prop, propEq } from 'rambda'

export default {
  methods: {
    syncArticleLaptopPrice(laptopId) {
      const price = pipe(
        find(propEq('id', laptopId)),
        prop('price'),
        defaultTo(null),
      )(this.laptopEvaluations)

      this.setArticleLaptop(laptopId, {
        price,
        isPriceCorrect: true,
      })
    },
  },

  render: () => '',
}
</script>
